export const mutations = {
  setMensagemSucesso(state, mensagemSucesso) {
    state.mensagemSucesso = mensagemSucesso;
  },
  setAuthenticated(state, authenticated) {
    state.authenticated = authenticated;
  },
};
